// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const warehouse_get = async ({ commit }, data) => {
  commit('warehouseLoading', true)
  let res;
  res = await sendReq('get', 'warehouses', data)
  commit('warehouses', res.data)
  commit('warehouseLoading', false)
}

export const warehouse_list = async ({ commit }, data) => {
  commit('warehouseLoading', true)
  let res;
  res = await sendReq('get', 'warehouses', data)
  commit('warehouses', res.data)
  commit('warehouseLoading', false)
}

export const warehouse_delete = async ({ commit }, data) => {
  commit('warehouseLoading', true)
  let res;
  res = await sendReq('delete', 'warehouses/'+data.id)
  commit('warehouseStatus', res.data)
  commit('warehouseLoading', false)
}

export const warehouse_edit = async ({ commit }, data) => {
  commit('warehouseLoading', true)
  let res;
  res = await sendReq('put', 'warehouses/'+data.id, data)
  commit('warehouseStatus', res.data)
  commit('warehouseLoading', false)
}

export const warehouse_add = async ({ commit }, data) => {
  commit('warehouseLoading', true)
  let res;
  res = await sendReq('post', 'warehouses', data)
  commit('warehouseStatus', res.data)
  commit('warehouseLoading', false)
}

export const warehouseproducts_get = async ({ commit }, data) => {
  commit('warehouseLoading', true)
  let res;
  res = await sendReq('get', 'warehouses/'+data.id+'/products', data)
  commit('warehouseProducts', res.data)
  commit('warehouseLoading', false)
}



// WEBPACK FOOTER //
// ./src/store/modules/Warehouse/Actions.js